/* 🤖 this file was generated by script */
export const wiconTrash04 = {
  name: 'trash_04',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 3h6M3 6h18m-2 0l-.7 10.52c-.1 1.58-.16 2.37-.5 2.96a3 3 0 01-1.3 1.22c-.62.3-1.4.3-3 .3h-3c-1.6 0-2.38 0-3-.3a3 3 0 01-1.3-1.21c-.34-.6-.4-1.4-.5-2.97L5 6"/></svg>`,
};
